"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var ScrollDiv_1 = __importDefault(require("components/Layout/ScrollDiv"));
var context_1 = __importDefault(require("components/Money/context"));
var PricingEstimateHeader_1 = __importDefault(require("./PricingEstimateHeader"));
var QuoteBenchmark_1 = __importDefault(require("./QuoteBenchmark"));
var ReportWrapper_1 = __importDefault(require("./ReportWrapper"));
var SummaryKPI_1 = __importDefault(require("./SummaryKPI"));
var VendorsQuote_1 = __importDefault(require("./VendorsQuote"));
var MONEY_CONTEXT_VAL = { asForeignCurrency: true, currency: 'AUD' };
var Report = function (_a) {
    var quoteReport = _a.quoteReport, _b = _a.showOnModal, showOnModal = _b === void 0 ? false : _b;
    return ((0, jsx_runtime_1.jsxs)(context_1.default.Provider, __assign({ value: MONEY_CONTEXT_VAL }, { children: [(0, jsx_runtime_1.jsx)(PricingEstimateHeader_1.default, { quoteReport: quoteReport, showButton: showOnModal }), (0, jsx_runtime_1.jsx)(ScrollDiv_1.default, { children: (0, jsx_runtime_1.jsxs)(ReportWrapper_1.default, { children: [(0, jsx_runtime_1.jsx)(SummaryKPI_1.default, { quoteReport: quoteReport }), (0, jsx_runtime_1.jsx)(QuoteBenchmark_1.default, {}), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ display: "flex", justifyContent: "space-between" }, { children: (0, jsx_runtime_1.jsx)(VendorsQuote_1.default, { quoteReport: quoteReport }) }))] }) })] })));
};
exports.default = Report;
